import React from "react";
import { useMediaQuery } from "react-responsive";

export default function HeaderLandingPage({ data }) {
    const isBigScreen = useMediaQuery({ query: "(min-width: 769px)" });

    return (
        <header className="header-landing-page">
            <img src={data?.logo ? data?.logo?.url : "/images/logo-white.svg"} alt="Logo" />

            <a rel="noopener noreferrer" href={data ? `/onboarding?id_parceiro=${data.id}` : `/onboarding`}>
                {isBigScreen ? "Acessar plataforma" : "Acessar"}
            </a>
        </header>
    );
}
